import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CHECKOUT_URL } from './CTAButton';
import { useCountdown } from './CountdownTimer';
type FloatingCTAProps = {
  triggerId: string;
};
export function FloatingCTA({
  triggerId
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  const {
    minutes,
    seconds
  } = useCountdown();
  useEffect(() => {
    const trigger = document.getElementById(triggerId);
    if (!trigger) return;
    const observer = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      setVisible(passed);
    }, {
      threshold: 0
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, [triggerId]);
  return <AnimatePresence data-id="element-32" data-mp="38b8la1fqwcls">
      {visible ? <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-gold-500/30 bg-navy-950/95 px-3 pb-[calc(env(safe-area-inset-bottom)+10px)] pt-3 backdrop-blur" data-id="element-33" data-mp="38d1vtrthbgz2">
          <div className="mx-auto flex max-w-3xl items-center gap-3" data-id="element-34" data-mp="2pbmnl7mece9k">
            <div className="hidden shrink-0 sm:block" data-id="element-35" data-mp="2uafvmkiwzd2c">
              <p className="font-display text-lg font-bold uppercase leading-none text-white" data-id="element-36" data-mp="2u8wdeodp6rxx">
                $27 USD
              </p>
              <p className="text-[11px] font-semibold uppercase tracking-wide text-gold-400" data-id="element-37" data-mp="2kdbfp2fnwdtz">
                Ends in {minutes}:{seconds}
              </p>
            </div>
            <a href={CHECKOUT_URL} className="flex w-full animate-shake items-center justify-center gap-2 rounded-xl bg-gold-500 px-4 py-3.5 text-center font-display text-[17px] font-extrabold uppercase leading-none tracking-wide text-navy-950 shadow-[0_6px_0_0_#B8810A] transition-[background-color,transform] duration-150 ease-out hover:bg-gold-400 active:translate-y-[3px] active:shadow-[0_3px_0_0_#B8810A] sm:text-xl" data-id="element-38" data-mp="2bcdbok5846be">
              <span aria-hidden="true" data-id="element-39" data-mp="33ghqsicahw0">🔧</span>
              <span data-id="element-40" data-mp="3uaj9bl23aq6r">Get access for $27</span>
            </a>
          </div>
          <p className="mt-1.5 text-center text-[10px] font-medium uppercase tracking-[0.1em] text-white/50 sm:hidden" data-id="element-41" data-mp="3ucvyoja6g2tu">
            Ends in {minutes}:{seconds} · 7-day guarantee
          </p>
        </motion.div> : null}
    </AnimatePresence>;
}